export const RISKS_TAG_MAP: Record<string, { borderColor: string; textColor: string; }> = {
  '': {
    borderColor: 'rgba(56, 127, 125, 0.6)',
    textColor: '#387F7D',
  },
  Product: {
    borderColor: 'rgba(80, 134, 243, 0.6)',
    textColor: '#5086F3',
  },
  Production: {
    borderColor: 'rgba(105, 209, 156, 0.6)',
    textColor: '#69D19C',
  },
  Tech: {
    borderColor: 'rgba(110, 119, 148, 0.6)',
    textColor: '#6E7794',
  },
  Operation: {
    borderColor: 'rgba(248, 215, 77, 0.6)',
    textColor: '#F8D74D',
  },
  Finance: {
    borderColor: 'rgba(127,111,241, 0.6)',
    textColor: '#7F6FF1',
  },
  'Market Competition': {
    borderColor: 'rgba(94, 200, 241, 0.6)',
    textColor: '#5EC8F1',
  },
  Legal: {
    borderColor: 'rgba(173, 83, 212, 0.6)',
    textColor: '#AD53D4',
  },
};
